// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disabled-link[data-v-f9e59cee] {\n  color: #82c1ea;\n  pointer-events: none;\n  text-decoration: none;\n}", ""]);
// Exports
module.exports = exports;
